import './SearchContent.less';

export const prefix = 'bm-c-search-content';

export const resultPrefix = 'bm-c-search-result';

export { default } from './SearchContent';
